import { useTranslation } from 'react-i18next';

export default function TemoignageLocal() {
  const { t } = useTranslation('pintendre');

  return (
    <section className="py-14 md:py-20 bg-[#1B2A4E]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-5 text-[#C77D3F]">
            <i className="ri-double-quotes-l text-3xl" />
          </div>
          <blockquote className="text-base md:text-lg text-white/90 leading-relaxed mb-6 italic">
            "{t('temoignage_quote')}"
          </blockquote>
          <div className="text-white/70 text-sm">
            <span className="font-semibold text-white">{t('temoignage_author')}</span>
            {' — '}
            {t('temoignage_rue')}, {t('temoignage_city')}
            <span className="block mt-1 text-white/50">{t('temoignage_detail')}</span>
          </div>
        </div>
      </div>

      <p className="text-white/40 text-xs mt-6 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}